/**
 * Created by v_luhaiping on 2018/8/24.
 */
import Cookies from 'js-cookie'
export const consultationFactory = {
  courrentObj:{},
  list: [
    {
      name: '北京',
      shortkey: 'bj',
      schoolId: 1,
      zixun: 'http://chat.looyu.com/chat/chat/p.do?c=27975&f=56820&g=22906&refer=gdlj',
      formid: 2125
    },
    {
      name: '上海',
      shortkey: 'sh',
      schoolId: 2,
      formid: 2126,
      configId: "32e9f85b-f810-48b1-8542-96e5b6ff9376"
    },
    {
      name: '广州',
      shortkey: 'gz',
      schoolId: 3,
      zixun: 'http://chat.looyuoms.com/chat/chat/p.do?c=20001700&f=10062122&g=10063142&refer=gdlj',
      formid: 2127
    },
    {
      name: '武汉',
      shortkey: 'wh',
      schoolId: 4,
      formid: 2128,
      configId: "e337fc4a-c40c-406c-b945-71296b1fa2f3"
    },
    {
      name: '天津',
      shortkey: 'tj',
      schoolId: 5,
      formid: 2129,
      configId: "f67876dd-ed80-414a-8bec-2ad2328db831"
    },
    {
      name: '西安',
      shortkey: 'xa',
      schoolId: 6,
      formid: 2130,
      configId: "e3167fec-271e-40f6-854f-e92265aefb9c"
    },
    {
      name: '南京',
      shortkey: 'nj',
      schoolId: 7,
      formid: 2131,
      configId: "c5f5feec-522d-4007-bec9-919ec5c8d583"
    },
    {
      name: '深圳',
      shortkey: 'sz',
      schoolId: 8,
      formid: 2132,
      configId: "05073e93-c3f1-4447-a210-8e09f154c4b2"
    },
    {
      name: '沈阳',
      shortkey: 'sy',
      schoolId: 9,
      formid: 2133,
      configId: "8916e2da-53ce-40cc-b45c-0d528486969f"
    },
    {
      name: '重庆',
      tenantId: 37608,
      shortkey: 'cq',
      schoolId: 10,
      formid: 2134
    },
    {
      name: '成都',
      shortkey: 'cd',
      schoolId: 11,
      formid: 2135,
      configId: "b59874f7-7658-4105-888a-0caf53cc94f8"
    },
    {
      name: '襄阳',
      shortkey: 'xy',
      schoolId: 14,
      formid: 2136,
      configId: "ed47dc58-bb85-4dda-b472-4491e7c57066"
    },
    {
      name: '哈尔滨',
      shortkey: 'heb',
      schoolId: 15,
      formid: 2137,
      configId: "7189ffbd-7e2e-4d50-9995-a27dfd9504fd"
    },
    {
      name: '长沙',
      tenantId: 32184,
      shortkey: 'cs',
      schoolId: 16,
      formid: 2138,
      configId: "73469c86-b70f-4eca-894e-0094bf2c833b"
    },
    {
      name: '长春',
      shortkey: 'cc',
      schoolId: 18,
      formid: 2139,
      configId: "38181aee-b033-4537-9ef6-a33e2b506139"
    },
    {
      name: '杭州',
      shortkey: 'hz',
      schoolId: 19,
      formid: 2140,
      configId: "f59617ad-4e7b-43da-909a-0050467cf56b"
    },
    {
      name: '郑州',
      shortkey: 'zz',
      schoolId: 20,
      formid: 2141,
      configId: "b0262a07-d6a1-4410-8917-40fae1b8642d"
    },
    {
      name: '太原',
      shortkey: 'ty',
      schoolId: 21,
      formid: 2142,
      configId: "2e2c7528-de1c-44a9-8ffa-d118ab8c1902"
    },
    {
      name: '济南',
      shortkey: 'jn',
      schoolId: 22,
      formid: 2143,
      configId: "be67af17-3db7-432a-ab15-c51378c12631"
    },
    {
      name: '苏州',
      shortkey: 'sz',
      schoolId: 23,
      formid: 2144,
      configId: "0d91ede4-be56-4e13-a139-ac31ed2a3811"
    },
    {
      name: '石家庄',
      shortkey: 'sjz',
      schoolId: 24,
      formid: 2145,
      configId: "371ac913-71df-427f-b35e-36b4dc580ec0"
    },
    {
      name: '合肥',
      shortkey: 'hf',
      schoolId: 25,
      formid: 2146,
      configId: "5f6c1b77-9ee9-401d-ad93-98ab22295020"
    },
    {
      name: '福州',
      shortkey: 'fz',
      schoolId: 26,
      formid: 2147,
      configId: "6264f110-2d21-405d-bda7-e1471070383e"
    },
    {
      name: '昆明',
      shortkey: 'km',
      schoolId: 27,
      formid: 2148,
      configId: "5f9b277d-02bf-49fd-b870-53673f30a278"
    },
    {
      name: '鞍山',
      shortkey: 'as',
      schoolId: 28,
      formid: 2149,
      configId: 'f1e1c79b-6cd5-432a-8531-89787a38a50a'
    },
    {
      name: '株洲',
      shortkey: 'zz',
      zixun: 'http://chat.looyu.com/chat/chat/p.do?c=27975&f=58197&g=23170&refer=gdlj',
      schoolId: 29,
      formid: 2150
    },
    {
      name: '佛山',
      shortkey: 'fs',
      schoolId: 30,
      formid: 2151,
      configId: "9b3e3ec2-4c1c-461d-8efb-14f9c36411b6"
    },
    {
      name: '宜昌',
      shortkey: 'yc',
      schoolId: 31,
      formid: 2152,
      configId: "e337fc4a-c40c-406c-b945-71296b1fa2f3"
    },
    {
      name: '无锡',
      shortkey: 'wx',
      schoolId: 32,
      formid: 2153,
      configId: "69009600-0249-43a9-a313-295e8642cffe"
    },
    {
      name: '荆州',
      shortkey: 'jz',
      schoolId: 34,
      formid: 2154,
      configId: "6ada461b-77be-4c1b-92bd-861ac0762cd4"
    },
    {
      name: '南昌',
      shortkey: 'nc',
      schoolId: 35,
      formid: 2155,
      configId: 'b3f64815-ddec-476c-a816-4e51314fbab6'
    },
    {
      name: '大连',
      shortkey: 'dl',
      schoolId: 36,
      formid: 2156,
      configId: "c653bdd5-2ade-4c6e-a5d1-67bd4ce30abc"
    },
    {
      name: '黄石',
      shortkey: 'hs',
      schoolId: 37,
      formid: 2157,
      configId: "dba5f0e8-f847-4c75-839d-165b8201b26c"
    },
    {
      name: '宁波',
      shortkey: 'nb',
      schoolId: 38,
      formid: 2158,
      configId: "e3c06d94-389d-4e03-b6b4-e0e2c5e9e6de"
    },
    {
      name: '兰州',
      shortkey: 'lz',
      schoolId: 40,
      formid: 2159,
      configId: "e4bb4e8b-001a-4686-885c-f221dd6972a1"
    },
    {
      name: '厦门',
      shortkey: 'xm',
      schoolId: 41,
      formid: 2160,
      configId: "5ea2066a-dc5e-4844-86a6-78b16ab74fc1"
    },
    {
      name: '青岛',
      shortkey: 'qd',
      schoolId: 44,
      formid: 2161,
      configId: "c3d9855c-5fd1-4adb-b6c8-8c4b58cb88be"
    },
    {
      name: '南宁',
      shortkey: 'nn',
      schoolId: 45,
      formid: 2162,
      configId: "b654ce8f-a55c-4fbf-8266-1f9bf79550c8"
    },
    {
      name: '徐州',
      shortkey: 'xz',
      schoolId: 46,
      formid: 2163,
      configId: "db59a2b0-ef53-4ca4-a5ee-945929002462"
    },
    {
      name: '湘潭',
      shortkey: 'xt',
      zixun: 'http://chat.looyu.com/chat/chat/p.do?c=27975&f=81356&g=33211&refer=gdlj',
      schoolId: 48,
      formid: 2164
    },
    {
      name: '镇江',
      shortkey: 'zj',
      schoolId: 49,
      formid: 2165,
      configId: "08e56951-54b4-463b-a723-6dbe7b6acdd6"
    },
    {
      name: '吉林',
      shortkey: 'jl',
      schoolId: 50,
      formid: 2166,
      configId: "c67c0e36-e499-4ae2-a8a6-e6cd662a8366"
    },
    {
      name: '南通',
      shortkey: 'nt',
      schoolId: 52,
      formid: 2167,
      configId: "4d9a2aad-631d-4faf-b64c-979e4a667634"
    },
    {
      name: '洛阳',
      shortkey: 'ly',
      schoolId: 53,
      formid: 2168,
      configId: "ba0c0bf4-5716-493c-b5a5-9994f142b6b6"
    },
    {
      name: '呼和浩特',
      shortkey: 'hhht',
      schoolId: 54,
      formid: 2169,
      configId: "44ad3861-5130-4df8-b2f4-d4c9bf59e241"
    },
    {
      name: '乌鲁木齐',
      shortkey: 'wlmq',
      schoolId: 55,
      formid: 2170,
      configId: "6b944ec2-688a-4c04-8429-4875b03f4735"
    },
    {
      name: '唐山',
      shortkey: 'ts',
      schoolId: 56,
      formid: 2171,
      configId: "db60271d-abcd-4478-9bd8-95b42fd1aab7"
    },
    {
      name: '贵阳',
      shortkey: 'gy',
      schoolId: 57,
      formid: 2172,
      configId: "eb816dac-af3f-41c2-a4f9-c8c6434c0e2d"
    },
    {
      name: '十堰',
      shortkey: 'sy',
      zixun: 'http://chat.looyu.com/chat/chat/p.do?c=27975&f==57316&g=72623&refer=gdlj',
      schoolId: 58,
      formid: 2173
    },
    {
      name: '温州',
      shortkey: 'wz',
      schoolId: 59,
      formid: 2175,
      configId: "9152ec8e-28c3-4d5e-b5e9-2fb849c2003e"
    },
    {
      name: '烟台',
      shortkey: 'yt',
      schoolId: 60,
      formid: 2176,
      configId: "0bc10714-9bf1-4ac0-a20c-327605526d3d"
    },
    {
      name: '潍坊',
      shortkey: 'wf',
      schoolId: 61,
      formid: '',
      configId: "370584f3-6528-4aea-913f-bb60a72ba460"
    },
    {
      name: '珠海',
      shortkey: 'zh',
      zixun: 'http://chat.looyu.com/chat/chat/p.do?c=27975&f=127813&g=91749&refer=gdlj',
      schoolId: 64,
      formid: 2177
    },
    {
      name: '扬州',
      shortkey: 'yz',
      zixun: 'http://chat.looyu.com/chat/chat/p.do?c=27975&f=129297&g=92626&refer=gdlj',
      schoolId: 66,
      formid: ''
    },
    {
      name: '保定',
      shortkey: 'bd',
      zixun: 'http://chat.looyu.com/chat/chat/p.do?c=27975&f=129568&g=93186&refer=gdlj',
      schoolId: 68,
      formid: 2178
    },
    {
      name: '永州',
      leyuId: "",
      shortkey: 'yz',
      zixun: '',
      schoolId: 69,
      formid: ''
    },
    {
      name: '锦州',
      shortkey: "jinzhou",
      schoolId: 71,
      formId: 2844,
      configId: 'b92a6d4c-1c24-452f-8014-b3de85b04c16'
    },
    {
      name: '开封',
      shortkey: "kf",
      schoolId: 82,
      //formId:2364,
      configId: 'c46b177b-e5b6-40e2-946e-d9904acb8ae7'
    },
    {
      name: '盐城',
      shortkey: "yc",
      schoolId: 86,
      formId: 2364,
      configId: '17a876d0-7347-4a18-968d-4b9e3b304e65'
    },
    {
      name: '连云港',
      shortkey: "lyg",
      schoolId: 87,
      formId: 2975,
      configId: '3a723b97-3c1d-4653-912a-f1ceaf5019cc'
    },
    {
      name: '秦皇岛',
      shortkey: 'qhd',
      schoolId: 73,
      formid: 2179,
      configId: '5034ce76-0837-4383-a96c-160e2c7e83ea'
    },
    {
      name: '邯郸',
      shortkey: 'hd',
      schoolId: 73,
      formid: 2181,
      configId: "6d772f16-558a-4ce9-a0c9-17853df1eb2c"
    },
    {
      name: '沧州',
      shortkey: 'cz',
      schoolId: 73,
      formid: 2180,
      configId: '6d86340d-c8e7-44ca-87cc-cd06a1dd46d2'
    },
    {
      name: '安阳',
      shortkey: 'ay',
      schoolId: 73,
      formid: 2182,
      configId: 'd5e946bd-5d1d-4d40-a557-930e50415061'
    },
    {
      name: '新乡',
      shortkey: "xx",
      schoolId: 518,
      formId: 2911,
      configId: '27a1dd08-c9d7-4966-aaea-936687a0ebe0'
    },
    {
      name: '东莞',
      shortkey: 'dg',
      schoolId: 506,
      formid: 2173,
      configId: '29fede08-d8b0-4e8c-809a-8494d7a0d3fd'
    },
    {
      name: '中山',
      shortkey: 'zs',
      schoolId: 507,
      formid: 2173,
      configId: '2fa04ec8-fb06-41fc-833b-a297da49be52'
    },
    {
      name: '海口',
      shortkey: 'hk',
      schoolId: 504,
      formid: 2173,
      configId: '6ec88dfe-5932-4d44-af40-d13d2a581bef'
    },
    {
      name: '绵阳',
      shortkey: "mianyang",
      schoolId: 517,
      formId: 2636,
      configId: '927959ed-fae9-4342-9953-737fddacabd4'
    },
    {
      name: '银川',
      shortkey: 'yc',
      schoolId: 505,
      formid: 2173,
      configId: '1cf345bb-7f94-4a0b-8249-e8007b673b72'
    }
  ],
  findById(id){
    let data={};
    console.log(this);
    const list=this.list;
    for (var i = 0; i < list.length; i++) {
      var obj = list[i];
      if(id==obj.schoolId){
        data=obj;
        break
      }
    }
    this.courrentObj=data;
    return data
  },
  openHref(data){

    Cookies.set('name','va')
    //let f_id=Cookies.get("Fingerprint_xdf");

    var a=Cookies.get('name');
    console.log(a);

   // var f_id = _this.myGetCookie('Fingerprint_xdf');
    let f_id=Cookies.get("Fingerprint_xdf");
    //let f_id='d85c691f7d6f09c32e552ca8682dd00e_1533001280590_0.7337758737167013';
    window.reseveKey = '#params:userId,' + f_id;
    window.reseveKey = '&r=' + encodeURIComponent(reseveKey);
    if (data.zixun) {
      var href = data.zixun;
      href += reseveKey;
      //$(this).find('a').attr('href', href.replace(/\s/g, ''));
      window.location.href=href
    } else if (data.configId) {
      easemobim.bind({
        configId :data.configId,
        hide : true,
        visitor : {
          userNickname : f_id
        }
      });
    } else {
      easemobim.bind({
        tenantId : data.tenantId,
        hide : true,
        visitor : {
          userNickname : f_id
        }
      });
    }
  }
};




// WEBPACK FOOTER //
// ./src/consultation.js